export default __webpack_public_path__ + "static/media/logo4.3db1ff80.jpg";